import React from 'react'
import PropTypes from 'prop-types'
import { Route as RouterRoute } from 'react-router-dom'
import { withSentryRouting } from '@sentry/react'

import GTM from './GTM/GTM'
import PrimaryBackNavigation from './Navigation/PrimaryBackNavigation'
import Location from './Location'
import Zendesk from './Zendesk/Zendesk'
import LogAuthUserActivity from './LogAuthUserActivity'
import RoutedModals from './Modal/RoutedModals'
import { ViewRouterContext } from './ViewRouter'

const RouteWithSentry = withSentryRouting(RouterRoute)

const Route = (props) => {
    const {
        id,
        render,
        component: Component,
        primaryCategory,
        pageType,
        isPrivateRoute = false,
        ...rest
    } = props

    const renderComponent = (routeProps) => {
        if (render || Component) {
            return render ? render(routeProps) : <Component {...routeProps} />
        }

        return null
    }

    return (
        <ViewRouterContext.Consumer>
            {() => (
                <RouteWithSentry
                    {...rest}
                    render={(routeProps) => {
                        return (
                            <main
                                id={`view-route--${id || null}`}
                                className="app__main"
                            >
                                <GTM pageType={pageType} primaryCategory={primaryCategory} />
                                <LogAuthUserActivity />
                                <Location />
                                <PrimaryBackNavigation />
                                <Zendesk />
                                {renderComponent(routeProps)}
                                <RoutedModals primaryRouteIsPrivate={isPrivateRoute} />
                            </main>
                        )
                    }}
                />
            )}
        </ViewRouterContext.Consumer>
    )
}

Route.propTypes = {
    primaryCategory: PropTypes.string.isRequired,
    pageType: PropTypes.string.isRequired,
    routeId: PropTypes.string,
    render: PropTypes.func,
    component: PropTypes.any,
}

export default Route
